import { useRef } from "react";
import { Kitchen3D } from "./kitchen3d/Kitchen3D";
import { SnapshotButtons } from "./kitchen3d/SnapshotButtons";

const Tag = ({ label, item, extra }) => (
  <div className="min-w-0" data-testid={`pair-preview-tag-${label.toLowerCase()}`}>
    <p className="font-mono-j text-[8px] sm:text-[9px] uppercase tracking-[0.25em] text-[#C5A059]">{label}</p>
    <p className="text-[11px] sm:text-xs text-[#F5F3EF] truncate">{item ? [item.name, extra].filter(Boolean).join(" · ") : "—"}</p>
  </div>
);

export const PairPreview = ({ board, stone, handle, finish, captureRef: externalRef }) => {
  const localRef = useRef(null);
  const captureRef = externalRef || localRef;
  const pair = { board, stone, handle, finish };
  return (
    <div className="relative w-full aspect-[4/3] sm:aspect-[16/9] overflow-hidden border border-[#D4AF37]/25 bg-[#0f0f13]" data-testid="pair-preview" data-lenis-prevent>
      <Kitchen3D {...pair} captureRef={captureRef} />
      <div className="absolute inset-x-3 bottom-3 sm:inset-x-auto sm:bottom-auto sm:left-4 sm:top-4 sm:max-w-[62%] grid grid-cols-3 gap-3 sm:gap-4 bg-[#0D0D11]/75 backdrop-blur-md border border-[#D4AF37]/25 px-3 py-2 sm:px-4 sm:py-3 pointer-events-none" data-testid="pair-preview-caption">
        <Tag label="Board" item={board} />
        <Tag label="Stone" item={stone} />
        <Tag label="Handle" item={handle} extra={finish} />
      </div>
      {(board || stone) && <SnapshotButtons captureRef={captureRef} pair={pair} />}
      {!board && !stone && (
        <p className="absolute inset-x-0 top-[40%] text-center font-display italic text-2xl text-[#A09E97] pointer-events-none" data-testid="pair-preview-empty">Pick a board and a stone</p>
      )}
    </div>
  );
};
